import { useSearchParams } from 'react-router-dom'
import { useToBigNumber } from '~/hooks/useToBigNumber'
import { toNumber } from '~/lib/helpers'

export function useLockParams() {
	const [searchParams, setSearchParams] = useSearchParams()

	const amount = searchParams.get('amount') ?? ''
	const weeks = toNumber(searchParams.get('weeks'))

	const amountBN = useToBigNumber(amount)

	const setAmount = (value: string) => {
		const newSearchParams = new URLSearchParams(searchParams)

		newSearchParams.set('amount', value)
		setSearchParams(newSearchParams, { replace: true })
	}

	const setWeeks = (value: number) => {
		const newSearchParams = new URLSearchParams(searchParams)

		newSearchParams.set('weeks', value.toString())
		setSearchParams(newSearchParams, { replace: true })
	}

	return {
		amount,
		amountBN,
		weeks,
		setAmount,
		setWeeks,
	}
}
